var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 21.55V7H7.3335V3H17.8835V11H21.8835V21.55H13.6085V17.275H11.6085V21.55H3.3335ZM5.6085 19.275H7.6085V17.275H5.6085V19.275ZM5.6085 15.275H7.6085V13.275H5.6085V15.275ZM5.6085 11.275H7.6085V9.275H5.6085V11.275ZM9.6085 15.275H11.6085V13.275H9.6085V15.275ZM9.6085 11.275H11.6085V9.275H9.6085V11.275ZM9.6085 7.275H11.6085V5.275H9.6085V7.275ZM13.6085 15.275H15.6085V13.275H13.6085V15.275ZM13.6085 11.275H15.6085V9.275H13.6085V11.275ZM13.6085 7.275H15.6085V5.275H13.6085V7.275ZM17.6085 19.275H19.6085V17.275H17.6085V19.275ZM17.6085 15.275H19.6085V13.275H17.6085V15.275Z",
    fill: "#1D5AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.8a9a69271c3b1cbb4e7e65c575bbc0c9.svg";
export { ForwardRef as ReactComponent };